import {useState,  useEffect, useRef} from 'react';
import {getDecryptCookie} from '../common/app_common.js';
import {getApiUser, putApiUserPermission, postApiUserDelete, checkPermission, PERMISSION_ADMIN} from '../common/fetch_api/api_common.js';
import {Title} from '../common/component_common.js';
import Button from 'react-bootstrap/Button';
import {BsKey, BsTrash} from 'react-icons/bs';
import {DecideWindow, ChangePassword} from '../common/modal_common.js';
import {AddUser} from './control_user/modals.js';
import '../common/css/control_users.css';

const PageControlUsers = () => {

    const [update, setUpdate] = useState(false);
    const [permission, setPermission] = useState(false);
    const [seletedUser, setSeletedUser] = useState('');

    const [modalAddUser, setModalAddUser] = useState(false);
    const closeModalAddUser = () => setModalAddUser(false);
    const showModalAddUser = () =>
    {
        setModalAddUser(true);
    };

    const [modalChangePw, setModalChangePw] = useState(false);
    const closeModalChangePw = () => setModalChangePw(false);
    const showModalChangePw = (name) =>
    {
        setSeletedUser(name);
        setModalChangePw(true);
    };

    const [userList, setUserList] = useState(null);
    const [decideBody, setDecideBody] = useState(null);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (name) =>
    {
        setSeletedUser(name);
        
        setDecideBtn('Delete');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to delete this User?</p>
            </div>
        );
        
        setModalDecide(true);
    }

    const onChangePermission = (e, userName) => {
        Promise.resolve( putApiUserPermission(userName, e.target.value) )
        .then( done => {
            //
        });
    }

    const onClickRemoveUser = (is) => {
        if( is )
        {
            Promise.resolve( postApiUserDelete(seletedUser) )
            .then( done => {
                runUpdate();
            });
        }
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        setPermission(checkPermission(PERMISSION_ADMIN));
        const getName = getDecryptCookie('using');
        
        Promise.resolve( getApiUser() )
        .then( userList => {
            
            // const userArr = userList.sort((a, b) => strArraySortAsc(a.username.toLowerCase(), b.username.toLowerCase()));
            setUserList( userList.map( (user) => (
                <tr key={`${user.username}_${user.permission}`}>
                    <td>{user.username}</td>
                    <td>
                        <select className="form-select form-select-sm" defaultValue={user.permission} disabled={`${user.username===getName?'disabled':''}`}
                            onChange={(e) => {onChangePermission(e, user.username)}}
                        >
                            <option value="admin">Admin</option>
                            <option value="operator">Operator</option>
                            <option value="monitoring">Monitoring</option>
                            <option value="guest">Guest</option>
                        </select>
                    </td>
                    <td>
                        <div className="d-flex">
                            <Button variant="secondary" className="btn btn-icon me-2" onClick={() => {showModalChangePw(user.username)}}><BsKey/></Button>
                            <Button variant={`${user.username===getName?'secondary':'danger'}`} className="btn btn-icon me-2"
                                onClick={() => {showModalDecide(user.username)}} disabled={`${user.username===getName?'disabled':''}`}><BsTrash/>
                            </Button>
                        </div>
                    </td>
                </tr>
            )));
        })
    }, [update]);

    return (
        <>
            <Title title='Users'></Title>
            {permission
            ? 
            <>
                <div className="d-flex justify-content-end">
                    <Button variant="primary" className="btn btn-sm me-2 mb-2" onClick={showModalAddUser}>Add User</Button>
                </div>
                <div className="d-flex">
                    <div className="section user-setting">
                        <div className="col-xxl-6 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>User Name</th>
                                        <th>Permission</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {modalDecide&&<DecideWindow result={onClickRemoveUser} show={modalDecide} handleClose={closeModalDecide} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
                {modalAddUser&&<AddUser show={modalAddUser} handleClose={closeModalAddUser} update={runUpdate}></AddUser>}
                {modalChangePw&&<ChangePassword username={seletedUser} show={modalChangePw} handleClose={closeModalChangePw} update={runUpdate}></ChangePassword>}
            </>
            :
            <>
                <div className="d-flex justify-content-center mt-2 me-2">
                    <div className='page-title'> Permission Denied </div>
                </div>
            </>
            }
        </>
    )
}

export default PageControlUsers;